import React from 'react';
import { Grid, Row, Col, Panel, FormGroup, Checkbox, Button, Radio } from 'react-bootstrap';
import { handleHttpResponse } from '../../lib/Helpers';
import User from '../../lib/User';
import { search } from '../../lib/Users';
import { MessageModal } from '../../components/Modals'
import UserSearchSnapshot from './UserSearchSnapshot'

class Users extends React.Component {
  state = {
    search_results: [],
  }

  getStyles(){
    return {
      label: {
        display: 'block'
      }
    }
  }

  search(e){
    const value = e.target.value;
    if(value.length > 3){
      search(value, 20, 0).then((response)=>{
        this.setState({search_results: response.result})
      })
    }
  }

  render() {
    const styles = this.getStyles();
    return(
      <div>
        <label style={styles.label}> Enter Name: </label>
        <input type="text" onChange={this.search.bind(this)} />
        <div>
          {this.state.search_results && this.state.search_results.map((user)=>{
            return(<UserSearchSnapshot key={user.swipecast_user_id} user={user}/>)
          })}
        </div>
      </div>
    )
  }
}

export default Users;
